import CabinetContests from '@/apps/CabinetContests'
import Layout from '@/apps/layout/components'
import CabinetLayout from '@/apps/layout/components/CabinetLayout'
import React from 'react'

const CabinetContestsPage = (): React.ReactElement => {
  return (
    <Layout>
      <CabinetLayout>
        <CabinetContests />
      </CabinetLayout>
    </Layout>
  )
}

export default CabinetContestsPage
